import { IApp } from "@/types";
import AbstractSource from "./AbstractSource";

class GoogleAnalyticsSource extends AbstractSource {
  getDataTypes(): IApp.DataType[] {
    return [
      IApp.DataType.GoogleAnalyticsTotal,
      IApp.DataType.GoogleAnalyticsPageViews,
      IApp.DataType.GoogleAnalyticsSessionCount,
      IApp.DataType.GoogleAnalyticsCityActiveUsers,
      IApp.DataType.GoogleAnalyticsEventCount,
      IApp.DataType.GoogleAnalyticsBrowserDeviceEventActiveUsers,
      IApp.DataType.GoogleAnalyticsDeviceActiveUsers,
      IApp.DataType.GoogleAnalyticsOrganicTotal,
      IApp.DataType.GoogleAnalyticsOrganicCityActiveUsers,
      IApp.DataType.GoogleAnalyticsOrganicDeviceActiveUsers
    ];
  }
}

export default GoogleAnalyticsSource;
